import { Component, input, computed } from '@angular/core';

export type FileIconSize =
  | 'extra-small'
  | 'small'
  | 'medium'
  | 'default'
  | 'large'
  | 'extra-large';

@Component({
  selector: 'xui-file-icon',
  templateUrl: './file-icon.component.html',
  styleUrls: ['./file-icon.component.scss'],
})
export class FileIconComponent {
  readonly extension = input<string>('');
  readonly size = input<FileIconSize>('default');
  readonly grayscale = input<boolean>(false);

  readonly sizeClass = computed(() => {
    switch (this.size()) {
      case 'extra-small':
        return 'file-icon-xs';
      case 'small':
        return 'file-icon-sm';
      case 'medium':
        return 'file-icon-md';
      case 'large':
        return 'file-icon-lg';
      case 'extra-large':
        return 'file-icon-xl';
      default:
        return '';
    }
  });
}
